<!--

FORMULARIO PARA ESCOLHER A APLICACAO E EFETUAR A ATIVACAO DA CONTA

-->


<template>
    <div class="registro">
        <header class="shared-header">
                    <div class="col-md-12 col-12 text-center">
                        <a class="valign" href="#">
                            <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png">
                        </a>
                    </div>
        </header>
        <transition name="fade">
            <div class="activation text-center" v-if="showSenha">
                <h2 class="title-principal">Defina uma senha</h2>
                <div class="row justify-content-center nb-margin-top">
                    <div class="col-md-3 col-6 box-login">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <v-label label="Defina uma senha"></v-label>
                                    <input ref="senha" type="password" class="form-control" v-model="senha" @keydown.enter="handleEnter('senha1')" placeholder="">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <v-label label="Repita a Senha"></v-label>
                                    <input ref="senha2" type="password" class="form-control" v-model="senha2" @keydown.enter="handleEnter('senha2')" placeholder="">
                                </div>
                            </div>
                        </div>
                        <div class="w-100">
                            <alert v-if="errmessages" type="warning" :close="false" :title="errmessages"></alert>
                        </div>
                        <br>
                        <div class="w-100">
                            <button type="button" class="login-button" style="width: 100%" @click="handleConfirmar" :disabled="logando">Confirmar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="activation text-center">
                <h2 class="title-principal" v-if="sucesso">Sucesso!</h2>
                <h3>Sua senha foi definida. Você será redirecionado à tela de login.</h3>
                <button type="button" class="activation-button" @click="handleLogin()">Ok</button>
            </div>
        </transition>

    </div>
</template>

<script>

import { apiORDSapp } from '../shared/api-functions'

export default {
    props: {
    },

    data() {
        return {
            errmessages: null,
            showSenha: true,
            sucesso: false,
            senha: null, 
            uuid: '',
        }
    },

    computed: {
    },

    methods: {

        handleConfirmar () {
            //BOTAO Confirmar
            this.errmessages = null

            if (this.senha !== this.senha2) {
                this.errmessages = 'As senhas não conferem'                
                this.$refs.senha2.focus()
                return
            }
            this.apiPost()
        },

        async apiPost () {
            this.sucesso = false
            this.showSenha = true
            var params = '?uuid=' + this.uuid
            var data = { senha: this.senha }
            const ativacao = await apiORDSapp(this, 'usuario/senha/' + params, 'post', data)
            this.$appLoading(false)
            if (ativacao.errmessages) {
              this.showSenha = false
              this.errmessages = login.errmessages
              return
            } else {
              this.showSenha = false
              this.sucesso = true
            }
        },

        handleEnter(campo) {
            if (campo === 'senha') {
                this.$refs.senha2.focus()
            } else {
                this.handleConfirmar()  
            }
        },

        handleLogin () {
            this.$router.push('/login')
        }
    },

    components: {
    },

    beforeCreate () {
    },

    mounted () {
    },

    created () {
        if (this.$route.query && this.$route.query.uuid) {
            this.uuid = this.$route.query.uuid
        } else {
            this.$router.push('/login')
        }
        
        this.$scrollTo(0)
        this.$nextTick(function () {
            this.$refs.senha.focus()
        })
        
    }

}

</script>

<style>

.shared-header {
    display: block;
    padding: 15px 0;
    margin-top: 15px;
}

.shared-header .valign {
    line-height: 30px;
    vertical-align: middle;
}

.activation {
    margin-top: 64px;
}

.activation h3 {
    margin-bottom: 32px;
    font-size: 30.4px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.58;
    letter-spacing: -.5px;
    color: #222;
    margin-top: 64px;
}

.activation-button {
    border: 2px solid #267da5!important;
    /* border-radius: 3px!important; */
    border-radius: 0.70rem;
    margin-top: 50px;
    cursor: pointer;
    width: 200px!important;
    height: 45px!important;
    background-color: #267da5!important;
    color: #fff!important;
    font-size: 15px!important;
}


.title-principal {
    color: #222;
    font-size: 36px;
    font-weight: 800;
    letter-spacing: -1.13px;
    line-height: 44px;
    margin: 25px 0 0;
}

.registro {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  /* display: table; */
  display: block;
  transition: opacity .3s ease;
  overflow: auto;
}

.login-button {
    border: 2px solid #267da5!important;
    border-radius: 0.70rem;
    cursor: pointer;
    height: 45px!important;
    background-color: #267da5!important;
    color: #fff!important;
    font-size: 15px!important;
}

.app {
    /* width: 270px; */
    width: 50%;
    /* height: 280px; */
    /* height: 280px; */
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px solid #E0E0E0;
    border-radius: 15px;
    padding: 15px;
    cursor: pointer;
    font-size: 22px;
    letter-spacing: -0.15px;
    line-height: 24px;
    transition: all .2s;
}

.app:hover {
    border: 3px solid #00CC62;
}

.active {
    border: 3px solid #00CC62;
}

.app .title {
    color: #222;
    margin-bottom: 32px;
    font-size: 22px;
    letter-spacing: -0.15px;
    line-height: 27px;
    display: flex;
    align-items: flex-end;
    flex: 1;
    transition: all .2s;
}

.app p {
    color: #757575;
    font-family: Open Sans, sans-serif;
    letter-spacing: -0.5px;
    font-size: 14px;
    line-height: 19px;
    flex: 1;
    transition: all .2s;
}

</style>



// WEBPACK FOOTER //
// src/forms/app-senha-usuario-form.vue